export default {
    combinedFuturesChart: {
        title: 'Fig C · Combined futures position (BASE + PEAK + OFF_PEAK)',
        subtitle: 'Reference — total stacked per bucket',
        ariaLabel:
            'Stacked area chart: BASE bottom layer 1 MW flat, PEAK 2.5 MW stacked during 08:00–20:00, OFF_PEAK 0.8 MW stacked during the flanks. Total = combined futures adjustment per bucket.',
        baseLabel: 'BASE ({mw} MW)',
        peakLabel: 'PEAK ({mw} MW · 08:00–20:00)',
        offPeakLabel: 'OFF_PEAK ({mw} MW · flanks)',
    },
}
